import styled from "@emotion/styled";
import { Ui } from "@silvertours/front-shared";
var StyledBadge = /*#__PURE__*/ styled(Ui.Badge, {
    target: "e10446j30"
})("margin-bottom:1.5rem;", function(param) {
    var isLargeAtMD = param.isLargeAtMD, theme = param.theme;
    return isLargeAtMD && "".concat(theme.mq("sm"), " {\n    margin-bottom: 3rem;\n  }");
});
export { StyledBadge };
